import React, { useState, useEffect } from "react";
import Goals from "./Goals";
import GameStart from "../../utils/GameStart";
import { DndProvider } from "react-dnd";
import { TouchBackend } from "react-dnd-touch-backend";
import Card from "react-bootstrap/Card";
import BackToGameList from "../../utils/BackToGameList";
import { HTML5Backend } from 'react-dnd-html5-backend'

function CategorySortsImages(props) {
  const [triggerTimer, setTriggerTimer] = useState();
  const [time, setTime] = useState(0);
  const [resetGame, setResetGame] = useState(0);
  const [timesPlayed, setTimesPlayed] = useState(0);
  const [gameComplete, setGameComplete] = useState(false);
  const [openGameStartModal, setOpenGameStartModal] = useState();
  const [dndEngine, setDNDEngine] = useState();
  const [dndEngineReady, setDNDEngineReady] = useState(false);

  const setEngine = () => {
    if(('ontouchstart' in window) ||
     (navigator.maxTouchPoints > 0) ||
     (navigator.msMaxTouchPoints > 0)){
      setDNDEngine(<DndProvider backend={TouchBackend}>
        <Card bg="light" style={{ marginTop: "50px" }}>
          <Goals
            setGameComplete={setGameComplete}
            errorChecking={props.errorCheck}
            timer={props.timerCheck}
            triggerTimer={triggerTimer}
            setTime={setTime}
            time={time}
            openGameStartModal={setOpenGameStartModal}
            timesPlayed={setTimesPlayed}
            resetGame={resetGame}
            onResetGame={setResetGame}
          />
        </Card>
      </DndProvider>)
      setDNDEngineReady(true)
     }else{
      setDNDEngine(( <DndProvider backend={HTML5Backend}>
        <Card bg="light" style={{ marginTop: "50px" }}>
          <Goals
            setGameComplete={setGameComplete}
            errorChecking={props.errorCheck}
            timer={props.timerCheck}
            triggerTimer={triggerTimer}
            setTime={setTime}
            time={time}
            openGameStartModal={setOpenGameStartModal}
            timesPlayed={setTimesPlayed}
            resetGame={resetGame}
            onResetGame={setResetGame}
          />
        </Card>
      </DndProvider>))
      setDNDEngineReady(true)
     };
     setDNDEngineReady(false)
  }

  const handleResetGame = () => {
    window.location.reload();
  };
  
    useEffect(() => {
      if (resetGame === 1) {
        handleResetGame();
      }
    }, [resetGame]);

  useEffect(() => {
    if(dndEngine === undefined){
      setEngine()
    }
  },[])

  return (<>
            {!dndEngineReady ?
                    <>
                      <BackToGameList />
                      <div
                        className="main-content"
                        style={{ margin: "20px", background: "rgb(240, 244, 249)" }}
                      >
                          <GameStart
                            check={props.errorCheck}
                            timer={props.timerCheck}
                            onStartTime={setTriggerTimer}
                            setTime={setTime}
                            openGameStartModal={openGameStartModal}
                            timesPlayed={timesPlayed}
                            setResetGame={setResetGame}
                            onGameStartModal={setOpenGameStartModal}
                            gameTitle={"Category Sorts"}
                            gameDescription={`To play, touch the "Start Game" button. 
                            Then touch and drag words into their respective categories.
                            Thank you for playing, and enjoy!`}
                          />
                          {dndEngine}
                        </div>
                      </> : <>Loading...</>}
        </>
  );
}

export default CategorySortsImages;
